/**
 * Shopify Forms (app embed) — match theme contact form inside Shadow DOM.
 * Must run before the Forms loader (see layout/theme.liquid).
 */
(function () {
  window.formStyles = window.formStyles || new Map();

  window.formStyles.set(
    '288-contact-form',
    `
:host {
  --cf-form-radius: var(--radius-section-outer);
  --cf-field-radius: var(--radius-card-outer);
  --form-field-border-radius: var(--cf-field-radius, var(--radius-card-outer));
  --button-border-radius: var(--cf-field-radius, var(--radius-card-outer));
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
  --container-max-w: 100%;
  --inline-container-max-width: 100%;
  --app-embed-padding-x: 0;
  --app-embed-padding-y: 0;
  --forms-padding-top: 0;
  --forms-padding-right: 0;
  --forms-padding-bottom: 0;
  --forms-padding-left: 0;
  --container-background-color: transparent;
  --form-field-border: none;
  --form-field-border-focused: none;
  --button-border: 2px solid var(--color-primary-button-text, #ff2a51);
  --form-text-color: var(--color-primary-button-text, #ff2a51);
  --form-placeholder-color: var(--color-primary-button-text, #ff2a51);
  --body-text-color: var(--color-primary-button-text, #ff2a51);
  --heading-text-color: var(--color-primary-button-text, #ff2a51);
  --button-background-color: var(--color-primary-button-text, #ff2a51);
  --button-text-color: var(--color-white, #ffffff);
}

._container_3eyaa_70,
._formContainer_1q1d2_30,
._inline_1q1d2_47,
._grid_1q1d2_148,
._gridItem_1q1d2_172,
._gridItemContent_1q1d2_257,
._formFieldset_cit2d_82 {
  box-sizing: border-box !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
}

._container_3eyaa_70,
._formContainer_1q1d2_30,
._inline_1q1d2_47 {
  box-shadow: none !important;
  overflow: hidden !important;
}

._grid_1q1d2_148 {
  display: block !important;
  grid-template-columns: none !important;
}

._gridItem_1q1d2_172._imageLoading_1q1d2_241,
._gridItem_1q1d2_172:empty {
  display: none !important;
}

._gridItemContent_1q1d2_257 {
  padding: 0 !important;
}

form {
  display: flex !important;
  flex-direction: column !important;
  gap: 6px !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
}

form > div,
._formFieldContainer_1mxsl_5,
._formPhoneInputContainer_piv1u_6,
._consentCheckboxContainer_cit2d_49 {
  box-sizing: border-box !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
}

._formFieldContainer_1mxsl_5 {
  display: block !important;
}

form > div:has(shop-lead-capture) {
  display: none !important;
}

form > section:has(iframe[src*='hcaptcha.com']),
form > div:has(iframe[src*='hcaptcha.com']),
section:has(iframe[data-hcaptcha-widget-id]),
section:has(textarea[name='h-captcha-response']) {
  display: none !important;
}

iframe[src*='hcaptcha.com'],
iframe[data-hcaptcha-widget-id],
textarea[name='h-captcha-response'],
textarea[id^='h-captcha-response-'] {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
  min-height: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  border: 0 !important;
  overflow: hidden !important;
  visibility: hidden !important;
  pointer-events: none !important;
}

@media screen and (max-width: 749px) {
  :host {
    --inline-container-max-width: 100% !important;
    --container-max-w: 100% !important;
    --app-embed-padding-x: 0 !important;
    --app-embed-padding-y: 0 !important;
    --forms-padding-top: 0 !important;
    --forms-padding-right: 0 !important;
    --forms-padding-bottom: 0 !important;
    --forms-padding-left: 0 !important;
  }

  ._inline_1q1d2_47,
  ._formContainer_1q1d2_30,
  ._container_3eyaa_70 {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  ._container_3eyaa_70 {
    display: block !important;
  }
}

@media screen and (min-width: 750px) {
  form {
    flex-direction: row !important;
    flex-wrap: wrap !important;
    align-items: stretch !important;
  }

  form > div:has(#first_name),
  form > div:has(#email) {
    flex: 1 1 calc(50% - 3px) !important;
    min-width: 0 !important;
  }

  form > div:has(#phone_number),
  form > div:has(textarea[name='custom#comment']),
  form > button[type='submit'] {
    flex: 1 1 100% !important;
  }
}

input[type='text'],
input[type='email'],
input[type='tel'],
textarea[name='custom#comment'],
._formInputField_nag3b_7,
._formPhoneInputField_piv1u_17,
._textArea_17mgw_1 {
  box-sizing: border-box !important;
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  height: auto !important;
  min-height: calc(var(--padding-lg, 1rem) * 2 + 1.25em) !important;
  margin: 0 !important;
  color: var(--color-primary-button-text, #ff2a51) !important;
  background: #ff2a510f !important;
  padding-block: var(--padding-lg, 1rem) !important;
  padding-inline: var(--padding-xl, 1.25rem) !important;
  border-radius: var(--cf-field-radius, var(--radius-card-outer)) !important;
  border: none !important;
  box-shadow: none !important;
  font-size: var(--font-paragraph--size, 1rem) !important;
  line-height: 1.25 !important;
  appearance: none !important;
  -webkit-appearance: none !important;
  -webkit-font-smoothing: antialiased !important;
}

@media screen and (max-width: 749px) {
  input[type='text'],
  input[type='email'],
  input[type='tel'],
  textarea[name='custom#comment'],
  ._formInputField_nag3b_7,
  ._formPhoneInputField_piv1u_17,
  ._textArea_17mgw_1,
  button[type='submit'],
  ._formSubmitButton_cit2d_96 {
    min-height: calc(var(--padding-lg, 1rem) * 2 + 1.25em) !important;
    padding-block: var(--padding-lg, 1rem) !important;
    padding-inline: var(--padding-xl, 1.25rem) !important;
    line-height: 1.25 !important;
  }
}

input:focus,
textarea[name='custom#comment']:focus,
._textArea_17mgw_1:focus {
  outline: none !important;
  box-shadow: none !important;
}

input::placeholder,
textarea[name='custom#comment']::placeholder,
._textArea_17mgw_1::placeholder {
  color: var(--color-primary-button-text, #ff2a51) !important;
  font-weight: 600 !important;
  opacity: 1 !important;
}

._formInputFieldLabel_1mxsl_38 {
  display: none !important;
}

.phone-country-selector {
  display: none !important;
}

._formPhoneInputContainer_piv1u_6 {
  display: block !important;
  width: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
  min-height: 0 !important;
  background: transparent !important;
  border: none !important;
}

._formPhoneInputContainer_piv1u_6 input {
  width: 100% !important;
}

._formPhoneInputField_piv1u_17::placeholder {
  color: var(--color-primary-button-text, #ff2a51) !important;
  font-weight: 600 !important;
  opacity: 1 !important;
}

textarea[name='custom#comment'],
._textArea_17mgw_1 {
  resize: vertical !important;
  min-height: var(--input-textarea-min-height, 55px) !important;
}

._formFieldContainer_1mxsl_5:has(textarea)::before {
  display: none !important;
}

._consentCheckboxContainer_cit2d_49 {
  padding: 0 !important;
  margin: 0 !important;
}

._verticalLayout_1hja3_8,
._checkboxFieldSet_1hja3_3 {
  width: 100% !important;
}

._verticalLayout_1hja3_8 {
  display: flex !important;
  justify-content: flex-start !important;
}

._checkboxField_1hja3_3 {
  display: inline-flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  width: auto !important;
  max-width: 100% !important;
  gap: var(--padding-sm, 0.5rem) !important;
  cursor: pointer !important;
}

._checkboxWrapper_1hja3_33 {
  display: flex !important;
  align-items: center !important;
  flex-shrink: 0 !important;
}

._checkboxField_1hja3_3 ._textBody_2aowh_10 {
  flex: 0 1 auto !important;
  min-width: 0 !important;
  color: var(--color-primary-button-text, #ff2a51) !important;
  font-weight: 600 !important;
}

input[type='checkbox'],
._checkboxInput_1hja3_38 {
  box-sizing: border-box !important;
  display: inline-block !important;
  width: var(--checkbox-size, 22px) !important;
  height: var(--checkbox-size, 22px) !important;
  min-width: var(--checkbox-size, 22px) !important;
  max-width: var(--checkbox-size, 22px) !important;
  min-height: var(--checkbox-size, 22px) !important;
  margin: 0 !important;
  padding: 0 !important;
  flex-shrink: 0 !important;
  appearance: none !important;
  -webkit-appearance: none !important;
  background: #ff2a510f !important;
  border: 2px solid var(--color-primary-button-text, #ff2a51) !important;
  border-radius: var(--cf-field-radius, var(--radius-card-outer)) !important;
  cursor: pointer !important;
  vertical-align: middle !important;
  position: relative !important;
}

input[type='checkbox']:focus,
._checkboxInput_1hja3_38:focus {
  outline: none !important;
  box-shadow: none !important;
}

input[type='checkbox']:checked,
._checkboxInput_1hja3_38:checked {
  background: var(--color-primary-button-text, #ff2a51) !important;
  border-color: var(--color-primary-button-text, #ff2a51) !important;
}

input[type='checkbox']:checked::after,
._checkboxInput_1hja3_38:checked::after {
  content: '' !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  width: 0.35em !important;
  height: 0.6em !important;
  border: solid var(--color-white, #ffffff) !important;
  border-width: 0 2px 2px 0 !important;
  transform: translate(-50%, -60%) rotate(45deg) !important;
}

button[type='submit'],
._formSubmitButton_cit2d_96 {
  box-sizing: border-box !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  height: auto !important;
  min-height: calc(var(--padding-lg, 1rem) * 2 + 1.25em) !important;
  margin-block-start: 0 !important;
  background: var(--color-primary-button-text, #ff2a51) !important;
  color: var(--color-white, #ffffff) !important;
  border: 2px solid var(--color-primary-button-text, #ff2a51) !important;
  border-radius: var(--cf-field-radius, var(--radius-card-outer)) !important;
  padding-block: var(--padding-lg, 1rem) !important;
  padding-inline: var(--padding-xl, 1.25rem) !important;
  outline: none !important;
  outline-offset: 0 !important;
  font-family: var(--button-font-family-primary) !important;
  font-size: var(--meta-250) !important;
  font-weight: var(--font-meta--weight) !important;
  font-style: var(--font-meta--style) !important;
  line-height: 1 !important;
  text-transform: var(--button-text-case-primary) !important;
  transition:
    background-color 0.3s ease,
    color 0.3s ease !important;
}

button[type='submit']:hover,
._formSubmitButton_cit2d_96:hover {
  color: var(--color-primary-button-text, #ff2a51) !important;
  background-color: transparent !important;
}
`
  );

  const PLACEHOLDERS = {
    first_name: 'Name',
    phone_number: 'Phone',
  };

  function clearPhonePrefix(field) {
    field.type = 'text';
    field.setAttribute('inputmode', 'tel');
    field.setAttribute('autocomplete', 'tel');
    field.placeholder = 'Phone';

    if (/^\+1\s*$/.test(field.value)) {
      field.value = '';
    }

    if (field.dataset.phone288Bound === 'true') return;
    field.dataset.phone288Bound = 'true';

    field.addEventListener('focus', () => {
      if (/^\+1\s*$/.test(field.value)) {
        field.value = '';
      }
    });
  }

  function patchShadowForm(shadowRoot) {
    shadowRoot.querySelectorAll('._formFieldContainer_1mxsl_5').forEach((container) => {
      if (container.dataset.patched288 === 'true') return;

      const field = container.querySelector('input, textarea');
      if (!field) return;

      container.dataset.patched288 = 'true';

      const label = container.querySelector('label');
      const placeholder =
        PLACEHOLDERS[field.id] ||
        label?.textContent?.trim() ||
        field.getAttribute('aria-label')?.trim();

      if (placeholder) {
        field.placeholder = placeholder;
      }

      label?.remove();
    });

    const phone = shadowRoot.querySelector('#phone_number');
    if (phone) clearPhonePrefix(phone);

    const widthChain =
      '._formContainer_1q1d2_30, ._inline_1q1d2_47, ._grid_1q1d2_148, ._gridItem_1q1d2_172, ._gridItemContent_1q1d2_257, ._formFieldset_cit2d_82, form, form > div, ._formFieldContainer_1mxsl_5, ._formPhoneInputContainer_piv1u_6';

    shadowRoot.querySelectorAll(widthChain).forEach((el) => {
      /** @type {HTMLElement} */ (el).style.setProperty('box-sizing', 'border-box');
      /** @type {HTMLElement} */ (el).style.setProperty('width', '100%');
      /** @type {HTMLElement} */ (el).style.setProperty('max-width', '100%');
      /** @type {HTMLElement} */ (el).style.setProperty('min-width', '0');
    });

    shadowRoot
      .querySelectorAll(
        'input:not([type="checkbox"]):not([type="radio"]), textarea, button[type="submit"]',
      )
      .forEach((field) => {
      if (
        field.name === 'h-captcha-response' ||
        (field.id && field.id.indexOf('h-captcha-response-') === 0)
      ) {
        return;
      }

      /** @type {HTMLElement} */ (field).style.setProperty('box-sizing', 'border-box');
      /** @type {HTMLElement} */ (field).style.setProperty('width', '100%');
      /** @type {HTMLElement} */ (field).style.setProperty('max-width', '100%');
      /** @type {HTMLElement} */ (field).style.setProperty('min-width', '0');
    });

    shadowRoot.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      /** @type {HTMLElement} */ (checkbox).style.removeProperty('width');
      /** @type {HTMLElement} */ (checkbox).style.removeProperty('max-width');
      /** @type {HTMLElement} */ (checkbox).style.removeProperty('min-width');
      /** @type {HTMLElement} */ (checkbox).style.setProperty('box-sizing', 'border-box');
      /** @type {HTMLElement} */ (checkbox).style.setProperty(
        'width',
        'var(--checkbox-size, 22px)',
        'important',
      );
      /** @type {HTMLElement} */ (checkbox).style.setProperty(
        'max-width',
        'var(--checkbox-size, 22px)',
        'important',
      );
      /** @type {HTMLElement} */ (checkbox).style.setProperty(
        'min-width',
        'var(--checkbox-size, 22px)',
        'important',
      );
    });

    shadowRoot
      .querySelectorAll(
        'section:has(iframe[src*="hcaptcha"]), section:has(textarea[name="h-captcha-response"])',
      )
      .forEach((el) => {
        /** @type {HTMLElement} */ (el).style.setProperty('display', 'none');
      });
  }

  function patchAllForms() {
    document.querySelectorAll('shopify-forms-embed').forEach((embed) => {
      if (embed.shadowRoot) patchShadowForm(embed.shadowRoot);
    });
  }

  // Performance: this file only loads on the contact page (see layout/theme.liquid).
  // Wait for window load, then watch ONLY the form embed(s) instead of the whole document.
  const watched = new WeakSet();
  let pending = false;

  function schedulePatch() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      patchAllForms();
    });
  }

  function watchEmbeds() {
    let found = false;
    document.querySelectorAll('shopify-forms-embed').forEach((embed) => {
      found = true;
      if (watched.has(embed)) return;
      watched.add(embed);
      if (embed.shadowRoot) {
        new MutationObserver(schedulePatch).observe(embed.shadowRoot, { childList: true, subtree: true });
      }
    });
    patchAllForms();
    return found;
  }

  function start() {
    // The embed is injected by the Shopify Forms loader; until it exists, watch the main
    // content container only (childList), then stop as soon as the form has been found.
    if (watchEmbeds()) return;
    const root = document.getElementById('MainContent') || document.body;
    const finder = new MutationObserver(() => {
      if (watchEmbeds()) finder.disconnect();
    });
    finder.observe(root, { childList: true, subtree: true });
    window.setTimeout(() => finder.disconnect(), 20000);
  }

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start, { once: true });
  }
})();
